var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('animatedLogo',{staticStyle:{"margin-top":"20vh"}}),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","margin-top":"15vh"}},[_c('router-link',{attrs:{"to":"/peter"}},[_c('button',{staticClass:"primary big-xl"},[_vm._v("Commencer")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b40e69f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/primary.vue
// module id = 47
// module chunks = 0